function SearchParentsFor( start, cls, top )
{
    var result;

    var parent = start.parentNode;
    if ( ( parent ) && (  parent.getAttribute ) )
    {
        var pcls = parent.getAttribute( "class" );
        if ( pcls )
        {
            var pclsArray = pcls.split( " " );
            for ( var i = 0; i < pclsArray.length; i++ )
            {
                if ( pclsArray[ i ] == cls )
                {
                    result = parent;
                    break;
                }
            }
        }

        if ( ( !result ) && ( ( !top ) || ( parent != top ) ) )
        {
            result = SearchParentsFor( parent, cls, top );
        }
    }

    return ( result );
}

///////////////////////////////////////////////////////////////////
// colorlist variant selector 'setupColourVariantSelector()'
//////////////////////////////////////////////////////////////////

function setupColourVariantSelector() 
{
    var Allcolorlist       = document.querySelectorAll( ".colorlist" );
    var colorlist_Allspan = document.querySelectorAll( ".colorlist_span" );

    colorlist_Allspan.forEach( ( colorlist_span ) => 
    {
        colorlist_span.addEventListener( "click", () => 
        {
            Allcolorlist.forEach(( list ) => 
            {
                list.classList.remove( 'active' );
            });    
            colorlist_span.closest('.colorlist').classList.add('active');
            var displayText = document.querySelector( ".product__variant--display-text" );
            var colorOption = colorlist_span.dataset.option;
            var colorValue  = colorlist_span.dataset.value;
            var selectors   = document.querySelectorAll( '.single-option-selector' );

            selectors.forEach( function( selector )
            {
                if( selector.dataset.option == colorOption )
                {
                    for( option in selector.options )
                    {
                        if( selector.options[ option ].value == colorValue )
                        {
                            selector.selectedIndex = selector.options[ option ].index;
                            if ("createEvent" in document) {
                                var evt = document.createEvent("HTMLEvents");
                                evt.initEvent("change", false, true);
                                selector.dispatchEvent(evt);
                            }
                            else {
                                selector.fireEvent("onchange");
                            }
                            // selector.dispatchEvent( new Event( 'change' ) );
                            if( displayText )
                            {
                                displayText = displayText.querySelector( "[data-product-variant-display-text]" );
                                displayText.innerText = colorValue;
                            }
                        }
                    }
                }
            });
            // var variantID = colorlist_span.dataset.variantid;
            // var productMasterSelect = document.querySelector( ".product-details:not(.hidden) select[ name='id' ]" );
            // var correctVariant = productMasterSelect.querySelector( "[value='" + variantID + "']" );
            // if( displayText )
            // {
            //     displayText = displayText.querySelector( "[data-product-variant-display-text]" );
            //     displayText.innerText = colorlist_span.dataset.colorName;
            // }
            // for( var i = 0; i < productMasterSelect.options.length; i++ )
            // {
            //     var option = productMasterSelect.options[ i ];
            //     option.removeAttribute( "selected", "selected" );

            //     if( option == correctVariant )
            //     {
            //         option.setAttribute( "selected", "selected" );
            //     }
            // }
            // checkRestockMessage();
            // GoToCorrectProductThumbnail( correctVariant );
            // UpdateOptionalExtras( correctVariant );

            var variant_price = colorlist_span.getAttribute("data-price");
            var variant_compare_price = colorlist_span.getAttribute("data-compare-price");
            var greyoutPrice = document.querySelector( ".greyout s");
            var normalPrice = document.querySelector( "#productPrice-product-template span:first-child" );

            if( greyoutPrice )
            {
                document.querySelector( ".greyout s").innerHTML = variant_compare_price;
            }
            if( normalPrice )
            {
                document.querySelector( "#productPrice-product-template span:first-child" ).innerHTML = variant_price;
            }
        });
    } );
}

function ParseQP( )
{
    var qpd   = { };
    var qp    = window.location.search.substr( 1 );
    var pairs = qp.split( "&" );

    for ( var i = 0; i < pairs.length; i++ )
    {
        var tuple = pairs[ i ].split( "=" );
        if ( ( tuple ) && ( tuple.length == 2 ) )
        {
            var key  = tuple[ 0 ];
            var val  = tuple[ 1 ];
            qpd[ key ] = decodeURIComponent( val );
        }
    }

    return ( qpd );
}

function makeDeliveryOptionActive( )
{
    // var parent            = document.querySelector( ".tabbedinfo" );
     if($(window).width()>768)
    {
        var tabLinksContainer = $( ".tabs.desktop #tab-links")[0];
    }else{
        var tabLinksContainer = $( ".tabs.mobile #tab-links")[0];
    }
    var tabAnchorTags     = tabLinksContainer.getElementsByTagName( "a" );
    for( var i = 0; i < tabAnchorTags.length; i++ )
    {
        var anchorTag = tabAnchorTags[ i ];
        anchorTag.classList.remove( "active" );

        if( anchorTag.title == "Delivery Options" )
        {
            anchorTag.classList.add( "active" );
        }        
    }

    if($(window).width()>768)
    {
        var tabTextContainer = $( ".tabs.desktop")[0];
    }else{
        var tabTextContainer = $( ".tabs.mobile")[0];
    }
    var tabTexts         = tabTextContainer.getElementsByTagName( "section" );
    for( var j = 0; j < tabTexts.length; j++ )
    {
        var tabText = tabTexts[ j ];
        tabText.classList.remove( "active" );

        if( tabText.dataset.name == "deliveryOptions" )
        {
            tabText.classList.add( "active" );
        }      
    }

    // parent.scrollIntoView( { behavior: "smooth" } )
}

function makeReviewOptionActive( )
{
    // var parent            = document.querySelector( ".tabbedinfo" );
    if($(window).width()>768)
    {
        var tabLinksContainer = $( ".tabs.desktop #tab-links")[0];
    }else{
        var tabLinksContainer = $( ".tabs.mobile #tab-links")[0];
    }
    var tabAnchorTags     = tabLinksContainer.getElementsByTagName( "a" );
    for( var i = 0; i < tabAnchorTags.length; i++ )
    {
        var anchorTag = tabAnchorTags[ i ];
        anchorTag.classList.remove( "active" );

        if( anchorTag.title == "Customer reviews" )
        {
            anchorTag.classList.add( "active" );
        }        
    }

    
    if($(window).width()>768)
    {
        var tabTextContainer = $( ".tabs.desktop")[0];
    }else{
        var tabTextContainer = $( ".tabs.mobile")[0];
    }
    var tabTexts         = tabTextContainer.getElementsByTagName( "section" );
    for( var j = 0; j < tabTexts.length; j++ )
    {
        var tabText = tabTexts[ j ];
        tabText.classList.remove( "active" );

        if( tabText.dataset.name == "reviews" )
        {
            tabText.classList.add( "active" );
        }      
    }

    // parent.scrollIntoView( { behavior: "smooth" } )
}

function ItsInTheFuture( dateStr )
{
    var inTheFuture = false;
    var parts       = dateStr.split( "-" );
    console.log(parts);
    console.log( dateStr );
    if ( parts.length == 3 )
    {
        var monthNum = Number( parts[ 1 ] ) - 1;
        console.log(monthNum);
        var dt       = new Date( parts[ 2 ], monthNum, parts[ 0 ], 0, 0, 0 );
        console.log(dt);

        if ( dt.getTime( ) > new Date( ).getTime( ) )
        {
            inTheFuture = true;
        }
    }
    
    return ( inTheFuture )
}

function HandleCartRestockDateProperty( restockDate, type )
{
    var inputTarget = document.querySelector( "[ data-product-form ] [name='properties[restock]']" )
    if( type == "set" )
    {
        if( inputTarget )
        {
            inputTarget.setAttribute( "value", restockDate );
        }
        else
        {
            var input = document.createElement( "input" );
            input.setAttribute( "type", "text" );
            input.setAttribute( "name", "properties[restock]" );
            input.setAttribute( "value", restockDate );
            input.setAttribute( "style", "display: none" );

            document.querySelector( "[ data-product-form ]" ).appendChild( input );
        }
    }
    else
    {
        if( inputTarget )
        {
            inputTarget.parentNode.removeChild( inputTarget );
        }
    }
}

function checkRestockMessage( targetButton )
{
    
    var restockDate;
    var available = false;
    var stock     = 0;
  	var variantAvailable;
    var productMasterSelect = document.querySelector( ".product-details:not(.hidden) select[ name='id' ]" );
    if ( ( productMasterSelect ) && ( productMasterSelect.selectedIndex >= 0 ) )
    {
        var option = productMasterSelect.options[ productMasterSelect.selectedIndex ];
        restockDate = option.getAttribute( "data-restock-date" );
        if ( restockDate )
        {
            while ( restockDate.includes( '/' ) )
            {
                restockDate = restockDate.replace( "/", "-" );
            }
        }
        
        if ( option.getAttribute( "data-variant-available" ) == "true" )
        {
            available = true;
        }
        var qtyStr = option.getAttribute( "data-variant-qty" );
        if ( qtyStr != undefined )
        {
            stock = Number( qtyStr );
        }
      	variantAvailable = option.getAttribute( "data-variant-available" );
    }
    var message             = document.getElementsByClassName( "bridgman-product-in-stock-text" );
    var restockContainerall    = document.querySelectorAll( ".restock-date-target" );
    // if ( message && ( restockDate ) && ( ItsInTheFuture( restockDate ) ) && ( stock < 5 ) )
    if ( ( available && stock <= 0 && !restockDate ) || ( message && restockDate && ItsInTheFuture( restockDate ) ) )
    {
        var messageAll             = document.querySelectorAll( ".bridgman-product-in-stock-text" );
        $.each(messageAll, function (index, message) { 
            message.innerHTML        = "Available for pre-order";
        });

        $.each(restockContainerall, function (index, restockContainer) { 
            if( stock <= 0 && !restockDate )
            {
                var restockMessage           = restockContainer.getAttribute( "data-oos-msg" );
                restockContainer.textContent = restockMessage;
            }
            else
            {
                var restockMessage          = restockContainer.getAttribute( "data-restock-msg" );
                if( restockContainer.dataset.customRestockMsg && restockContainer.dataset.customRestockMsg != "" )
                {
    
                    restockContainer.textContent  = restockContainer.getAttribute( "data-custom-restock-msg" );
                    document.querySelector('.bridgman-product-in-stock-text').innerHTML = "MADE TO ORDER";
                }
                else
                {
                    restockContainer.textContent  = restockMessage + " " + restockDate;
                }
            }
            restockContainer.classList.remove( "hidden" );
        });

        HandleCartRestockDateProperty( restockDate, "set" );
    }
    else if( message && ( stock <= 0 ) )
    {
        var messageAll             = document.querySelectorAll( ".bridgman-product-in-stock-text" );
        $.each(messageAll, function (index, message) { 
            message.innerHTML = 'Out of stock';
        });

        $('.variant-quantity').removeClass('is-visible');

        $.each(restockContainerall, function (index, restockContainer) { 
            // restockContainer.classList.add( "hidden" );
        
            if( restockContainer.dataset.customRestockMsg && restockContainer.dataset.customRestockMsg != "" )
            {
                restockContainer.textContent  = restockContainer.getAttribute( "data-custom-restock-msg" );
                restockContainer.classList.remove( "hidden" );
                document.querySelector('.bridgman-product-in-stock-text').innerHTML = "MADE TO ORDER";
            }
        });

        HandleCartRestockDateProperty( null, "unset" );
    }
    else
    {
        var messageAll = document.querySelectorAll( ".bridgman-product-in-stock-text" );
        $.each(messageAll, function (index, message) { 
            message.innerHTML = 'In Stock';
        });
        if(stock < 10)
        {
            console.log("in")
            $('.variant-quantity').addClass('is-visible');
            $.each(messageAll, function (index, message) { 
                message.innerHTML = 'Low Stock';
            });
            var quantityMessageAll = document.querySelectorAll( "#variantQuantity-product-template__message" );
            $.each(quantityMessageAll, function (index, message) { 
                message.innerHTML = `Only ${stock} left!`;
            });
        }
        else
        {
            $('.variant-quantity').removeClass('is-visible');
        }
        $.each(restockContainerall, function (index, restockContainer) { 
            // restockContainer.classList.add( "hidden" );
            if( restockContainer.dataset.customRestockMsg && restockContainer.dataset.customRestockMsg != "" )
            {
                restockContainer.textContent  = restockContainer.getAttribute( "data-custom-restock-msg" );
                restockContainer.classList.remove( "hidden" );
                document.querySelector('.bridgman-product-in-stock-text').innerHTML = "MADE TO ORDER";
            }
        });

        HandleCartRestockDateProperty( null, "unset" );
    }

    if ( targetButton != undefined )
    {
        var button = targetButton[0];
    }
    else
    {
        var button = document.querySelector( "#addToCartForm-product-template .submit-btton" );
    }    
    var stickyButton = document.querySelector( "#bridgman-sticky-add-to-cart-btn" );
    var qtySelector = document.querySelector( ".qty-seleter" );
    
    if ( !available )
    {
        $( "#addToCartForm-product-template .submit-btton" ).find(".primary-text").text($( "#addToCartForm-product-template .submit-btton" ).attr("data-so-label"));
        $( "#bridgman-sticky-add-to-cart-btn" ).text($( "#bridgman-sticky-add-to-cart-btn").attr("data-so-label"));
        // button.querySelector( ".primary-text" ).innerHTML = button.getAttribute( "data-so-label" );
        button.setAttribute( "disabled", "disbaled" );
        button.setAttribute( "style", "padding: 8px;" );
        stickyButton.setAttribute( "disabled", "disbaled" );

        $( "#addToCartForm-product-template .submit-btton" ).find(".fa").hide();
        // button.querySelector( ".fa" ).setAttribute( "style", "display: none" );
        qtySelector.classList.add('hidden');
    }
    // else if ( stock > 0 )
    else if ( stock > 0 && !restockDate )
    {
        $( "#addToCartForm-product-template .submit-btton" ).find(".primary-text").text($( "#addToCartForm-product-template .submit-btton" ).attr("data-atc-label"));
        $( "#bridgman-sticky-add-to-cart-btn" ).text($( "#bridgman-sticky-add-to-cart-btn").attr("data-atc-label"));
        // button.querySelector( ".primary-text" ).innerHTML = button.getAttribute( "data-atc-label" );
        button.removeAttribute( "disabled", "disbaled" );
        button.removeAttribute( "style", "padding: 10px;" );
        stickyButton.removeAttribute( "disabled", "disbaled" );

        $( "#addToCartForm-product-template .submit-btton" ).find(".fa").hide();
        // button.querySelector( ".fa" ).setAttribute( "style", "display: none" );
        qtySelector.classList.remove('hidden');
    }
    // else
    // {
    //     button.querySelector( ".primary-text" ).innerHTML = button.getAttribute( "data-po-label" );
    //     button.removeAttribute( "disabled", "disbaled" );
    //     button.removeAttribute( "style", "padding: 10px;" );
    //     button.querySelector( ".fa" ).setAttribute( "style", "display: none" );
    // }
    else if( stock <= 0 || restockDate && ItsInTheFuture( restockDate ) && button )
    {
        // console.log(button.getAttribute( "data-po-label" ) + ':::');
        $( "#addToCartForm-product-template .submit-btton" ).find(".primary-text").text($( ".submit-btton" ).attr("data-po-label"));
        $( "#bridgman-sticky-add-to-cart-btn" ).text($( "#bridgman-sticky-add-to-cart-btn").attr("data-po-label"));
        // button.querySelector( ".primary-text" ).innerHTML = button.getAttribute( "data-po-label" );
        button.removeAttribute( "disabled", "disbaled" );
        button.removeAttribute( "style", "padding: 10px;" );
        stickyButton.removeAttribute( "disabled", "disbaled" );

        $( "#addToCartForm-product-template .submit-btton" ).find(".fa").hide();
        // button.querySelector( ".fa" ).setAttribute( "style", "display: none" );

        // var qtySelector = document.querySelector( ".qty-seleter" );
        // var children = qtySelector.childNodes;
        // for( var i = 0; i < children.length; i++ )
        // {
        //     var child = children[ i ];
        //     child.remove()
        // }
        if( restockDate && ItsInTheFuture( restockDate ) && button )
        {
            qtySelector.classList.remove('hidden');
        }
        else
        {
            qtySelector.classList.add('hidden');
        }

        var label = qtySelector.getElementsByTagName( "label" )[ 0 ]
        if( label )
        {
            label.remove();
        }

        var preorderQty = option.getAttribute( "data-variant-qty" );

        if( preorderQty > 0 )
        {
            if( !document.querySelector( ".preorder-message" )) 
            {
                var preOrderQtyMessage = document.createElement( "p" );
                preOrderQtyMessage.classList.add( "preorder-message" );
                preOrderQtyMessage.innerText = "Preorder quantity: " + preorderQty;
        
                qtySelector.appendChild( preOrderQtyMessage );
            }
        }
    }
}

///////////////////////////////////////////////////////////////////
//Custom product page selector functionality
//////////////////////////////////////////////////////////////////
function setupVariantSelector()
{
    $( ".bridgman-custom-selector" ).on( "click", function( e )
    {
        // console.log( "clicked" );
        var selected        = e.currentTarget.getAttribute( "data-value" );
        var selectedText    = e.currentTarget.getAttribute( "data-text" );
        var optionAttribute = e.currentTarget.getAttribute( "data-option" );
        var previous        = document.querySelector( ".bridgman-selected-option[ data-option='" + optionAttribute + "']" );
        
        if ( previous )
        {
            previous.classList.remove( "bridgman-selected-option" );
        }
        e.currentTarget.classList.add( "bridgman-selected-option" );

        var radio = e.currentTarget.querySelector( "input[type='radio']" );
        if ( radio )
        {
            radio.checked = true;
        }

        if ( ( selectedText == undefined ) || ( selectedText.length == 0 ) )
        {
            selectedText = selected; // apply a default
        }

        var selector        = '#productSelect-product-template-option-' + ( Number( e.currentTarget.getAttribute( "data-option" ) ) - 1 );
        var selectElement   = document.querySelector( selector );

        for ( var i = 0; i < selectElement.options.length; i++ )
        {
            if ( selectElement.options[ i ].value == selected )
            {
                selectElement.selectedIndex = i;
                break;
            }
        }

        $( selectElement ).change( );
        $( selectElement ).trigger( 'change' );
        $( selectElement ).val( selectElement.options[ selectElement.selectedIndex ].value ).trigger( "change" );
        var correctVariant = GetCorrectVariant();
        checkRestockMessage();
        GoToCorrectProductThumbnail( correctVariant );
        UpdateOptionalExtras( correctVariant );
    } );
}

function GetCorrectVariant()
{
    var selects = document.querySelectorAll( ".single-option-selector" );
    var options = { "option1" : "", "option2" : "", "option3" : "" };
    var correctOption;

    for( var  i = 0; i < selects.length; i++ )
    {
        var select = selects[ i ];
        options[ select.dataset.option ] = select.value;
    }

    //update the main select
    var productSelect = document.getElementById( "productSelect-product-template" );
    for( var i = 0; i < productSelect.options.length; i++ )
    {
        var option = productSelect.options[ i ];
        option.removeAttribute( "selected", "selected" );

        if( ( options.option1 != "" ) && ( options.option2 != "" ) && ( options.option3 != "" )  )
        {
            if( ( option.dataset.option1 == options.option1 ) && ( option.dataset.option2 == options.option2 ) && ( ( option.dataset.option3 == options.option3 ) ) )
            {
                option.setAttribute( "selected", "selected" );
                correctOption = option;
                // UpdatePrice( option );
            }
        }
        else if( ( options.option1 != "" ) && ( options.option2 != "" ) )
        {
            if( ( option.dataset.option1 == options.option1 ) && ( option.dataset.option2 == options.option2 ) )
            {
                option.setAttribute( "selected", "selected" );
                correctOption = option;
                // UpdatePrice( option );
            }
        }
        else if( ( options.option1 != "" ) )
        {
            if( ( option.dataset.option1 == options.option1 ) )
            {
                option.setAttribute( "selected", "selected" );
                correctOption = option;
                // UpdatePrice( option );
            }
        }
        else
        {
            //must be a default
            option.setAttribute( "selected", "selected" );
            correctOption = option;
            // UpdatePrice( option );
        }
    }
  
    if ( correctOption == undefined )
    {
        correctOption = document.createElement( "option" );
        correctOption.disabled = true;
        correctOption.setAttribute( "data-price", "" );
    }
  
    return correctOption;
}

function GoToCorrectProductThumbnail( correctVariant )
{
    var image   = correctVariant.dataset.variantImage;
    var thumbs  = document.querySelectorAll( ".bridgman_product_variant_image" );
    var target;

    for( var i = 0; i < thumbs.length; i++ )
    {
        var thumb = thumbs[ i ];

        if( thumb.dataset.image == image )
        {
            thumb.click();
            target = thumb.parentNode;
            break;
        }
    }
}

function UpdateOptionalExtras( correctVariant )
{
    var optionalExtraSection = document.querySelector( ".optionalExtras" );
    if( optionalExtraSection )
    {
        var optionalExtras = optionalExtraSection.querySelectorAll( ".optional-single-products" );
        for( var i = 0; i < optionalExtras.length; i++ )
        {
            var optionalExtra   = optionalExtras[ i ];
            var input           = optionalExtra.querySelector( "input" );
            var select          = optionalExtra.querySelector( "select" );

            if( select && select.options && select.options.length )
            {
                for( var j = 0; j < select.options.length; j++ )
                {
                    var option = select.options[ j ];
                    if( correctVariant.dataset.allOption == option.dataset.allVal )
                    {
                        option.setAttribute( "selected", "selected" );
                        input.value = option.value;
                    }
                }
            }
        }
    }
}

function HandleStickyATC( type )
{
    var stickyWrapper = document.querySelector( ".bridgman-sticky-atc-wrapper" );
    var stickyATC = document.querySelector( ".bridgman-sticky-add-to-cart-btn" );
    var regularATC = document.querySelector( ".bridgman-add-to-cart-btn" );
    var header = document.querySelector( ".header-section.bridgman-header" );

    if( type == "load" )
    {
        stickyWrapper.style.top = (header.offsetHeight -1) + "px";
    }

    if( regularATC.getBoundingClientRect().top <= header.offsetHeight )
    {
        stickyWrapper.classList.add( "sticky-active" );
    }
    else
    {
        if( stickyWrapper.classList.contains( "sticky-active" ) )
        {
            stickyWrapper.classList.remove( "sticky-active" );
        }
    }

    if( stickyATC.hasAttribute( "loaded" ) == false )
    {
        stickyATC.setAttribute( "loaded", "" );
        stickyATC.addEventListener( "click", function()
        {
            regularATC.click();
        });
    }
}

HandleStickyATC( "load" );

window.addEventListener( "DOMContentLoaded", function()
{
    HandleABTest();
    checkRestockMessage();
    var optionSelects = document.querySelectorAll( ".single-option-selector" );
    if( optionSelects && optionSelects.length )
    {
        for( var i = 0; i < optionSelects.length; i++ )
        {
            var optionSelect = optionSelects[ i ];
            optionSelect.addEventListener( "change", function( e ) 
            {
                var correctVariant = GetCorrectVariant();
                checkRestockMessage();
                GoToCorrectProductThumbnail( correctVariant );
                UpdateOptionalExtras( correctVariant );
            } );
        }
    }

    $(".product-variants-v2").on("change",function(){
        checkRestockMessage();
    })

    $(document).on('change',".optional-single-products input:checkbox[name='optionalid']",function() 
    {
        $(this).parents('label').toggleClass('active');
        
        var mainproductvariant = $("#productSelect-product-template option:selected").attr('data-all-option');
        if ($(this).is(':checked')) {
          $(this).parents('.optional-single-products').find('.upsellVariants').find('option').each(function() {
            var newOption = $(this).attr('data-all-val');
            
            if(mainproductvariant == newOption){
              var valueofnew = $(this).val();
              $(this).parents('.optional-single-products').find("input").val(valueofnew);
            }
          });
        }  
      });

      HandleLiveShopping()
} );

window.addEventListener( "scroll", function()
{
    HandleStickyATC( "scroll" );
});

window.addEventListener( "resize", function()
{
    HandleStickyATC( "load" );
});

function HandleLiveShopping()
{
    var target = document.querySelector( ".bridgman-live-shopping-container" );
    if( target )
    {
        $( target ).on( "click", function( e )
        {
            HandleLiveShoppingClick();
        } );
    }
}

function HandleLiveShoppingClick()
{
    var conferWithTarget = document.querySelector( "#conferwith .widgetContainer #conferwith-start-video-call.dr-btn" );
    if( conferWithTarget )
    {
        conferWithTarget.click();
    }
}

function HandleABTest()
{
    // var qp = ParseQP();

    // if( qp.ab )
    // {
    //     var body = document.querySelector( "body" );
    //     body.classList.add( "ab-test-" + qp.ab );
    // }
    // else if( qp.pl && qp.pl == "b" )
    // {
    //     var p2 = document.querySelector( ".bridgman-product-v2" ).classList.remove( "hidden" );
    // }
    // else if( !qp.pl || qp.pl && qp.pl == "a" )
    // {
    //     var p1 = document.querySelector( ".bridgman-product-v1" ).classList.remove( "hidden" );
    // }
}
function OptionalExtrasV2()
{
    var optionalExtrasElements = document.querySelectorAll( ".optional-extras-el" );

    for( var i = 0; i < optionalExtrasElements.length; i++ )
    {
        var optionalExtrasElement = optionalExtrasElements[ i ];
        if( optionalExtrasElement.classList.contains( "hidden" ) )
        {
            optionalExtrasElement.classList.remove( "hidden" );
        }
        else
        {
            optionalExtrasElement.classList.add( "hidden" );
        }
    }
}

window.addEventListener( "DOMContentLoaded", function()
{
    var excerptReadMore = document.querySelector( "#description-excerpt .tab-grid" );
    if( excerptReadMore )
    {
        excerptReadMore.addEventListener( "click", function( e )
        {
            e.preventDefault();
            var descriptionTab = document.querySelector( "#tab-links a[href='#tab-description'" );
            if( descriptionTab.classList.contains( "active" ) )
            {
                descriptionTab.scrollIntoView({behaviour:'smooth'});
                window.scrollBy(0, -250);
            }
            else
            {
                descriptionTab.click();
            }
        } );
    }
} );

window.addEventListener( "load", function()
{
    setupVariantSelector();
    setupColourVariantSelector();

    $( '.optional-extra-control-target' ).on( 'click', function( e )
    {
        e.stopPropagation();
        OptionalExtrasV2()
    } );

    
    $( '.option-extras-v2-overlay.optional-extras-el' ).on( 'click', function( e )
    {
        $(this).addClass('hidden');
        $('.option-extras-v2-popup.optional-extras-el').addClass('hidden');
        
    } );
} );